import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment';
import CustomTableFilters from '@/components/tableWithActions/CustomTableFilters.vue';
import { CutOrTubesDeviceGanttStatus } from '@/models/Charts/chartsData';
import ZoomSelector from '@/components/tableFilters/ZoomSelector.vue';
import StateFilter from '@/components/tableFilters/StateFilter.vue';
import { getStateColour } from '@/utils/color';
import { values } from '@/utils/enum';
import { useI18n } from '@/composables/i18n';
import { computed, onMounted, ref, watch } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CutOrTubesIntradayAvailabilityFilters',
  props: {
    defaultZoom: null
  },
  emits: ["filters-change"],
  setup(__props: any, { emit }: { emit: ((
      e: 'filters-change',
      states: string[],
      zoom: [Date, Date],
      areApplying: boolean,
    ) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  defaultZoom: [Date, Date];
};

const DEFAULT_SLIDER_START_VALUE = 0;





const { t } = useI18n();

const states = values(CutOrTubesDeviceGanttStatus);

const selectedStates = ref<string[]>(states);
const zoomValue = ref<[number, number]>([
  DEFAULT_SLIDER_START_VALUE,
  DEFAULT_SLIDER_START_VALUE,
]);
const startTimestamp = ref<moment.Moment>(moment.utc().subtract(24, 'hours'));

onMounted(() => {
  initializeIntradayAvailability();
});

function initializeIntradayAvailability() {
  initializeTimestamps();
  initializeValue();
}

function initializeTimestamps() {
  startTimestamp.value = moment(props.defaultZoom[0]);
}

function initializeValue() {
  zoomValue.value = [DEFAULT_SLIDER_START_VALUE, totalMinutes.value];
}

function emitFilters() {
  const newZoomValues: [Date, Date] = [
    moment(startTimestamp.value).add(zoomValue.value[0], 'minutes').toDate(),
    moment(startTimestamp.value).add(zoomValue.value[1], 'minutes').toDate(),
  ];
  const areApplying = !(
    selectedStates.value.length === states.length &&
    zoomValue.value[0] === DEFAULT_SLIDER_START_VALUE &&
    zoomValue.value[1] === totalMinutes.value
  );
  emit('filters-change', selectedStates.value, newZoomValues, areApplying);
}

function clearAllFilters() {
  selectedStates.value = states;
  zoomValue.value = [DEFAULT_SLIDER_START_VALUE, totalMinutes.value];
  emitFilters();
}

const totalMinutes = computed<number>(() =>
  moment(props.defaultZoom[1]).diff(props.defaultZoom[0], 'minutes'),
);

watch(
  () => props.defaultZoom,
  () => {
    initializeIntradayAvailability();

    // The following code handles the case when the table is refreshed (and thus the defaultZoom changed)
    // and we want to update the filter state.
    // If only the zoom was being used, and now that the defaultZoom was reset,
    // no filter is being used and the table must be notified (by sending areApplying to false)
    const areApplying = selectedStates.value.length !== states.length;
    emit(
      'filters-change',
      selectedStates.value,
      props.defaultZoom,
      areApplying,
    );
  },
);

return { __sfc: true,DEFAULT_SLIDER_START_VALUE, props, emit, t, states, selectedStates, zoomValue, startTimestamp, initializeIntradayAvailability, initializeTimestamps, initializeValue, emitFilters, clearAllFilters, totalMinutes, CustomTableFilters, ZoomSelector, StateFilter, getStateColour }
}

})